import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'
import translate from '@i18n'

interface EnhancedSearchResultsHeaderProps {
  isLoading: boolean
  totalElements: number
  searchTerm: string
}

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4, spacing16, spacing56 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing4};
    margin-top: ${spacing56};
    ${desktopCSS(css`
      margin-top: ${spacing16};
    `)}
  `}
`

const StyledTitle = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: smallHeadingCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    text-align: left;
    ${smallHeadingCSS};
    color: ${textDefault};
  `}
`

const StyledSubTitle = styled.span`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodyCopyCSS },
        },
      },
      colors: { textWeak },
    },
  }) => css`
    text-align: left;
    ${xxsmallBodyCopyCSS};
    color: ${textWeak};
  `}
`

const StyledSearchResultsNumber = styled.span`
  ${({
    theme: {
      typography: {
        catchword: {
          small2: { bundledCSS: small2CatchwordCSS },
        },
      },
      colors: { textWeak },
    },
  }) => css`
    text-align: left;
    ${small2CatchwordCSS};
    color: ${textWeak};
  `}
`

const EnhancedSearchResultsHeader: FunctionComponent<
  EnhancedSearchResultsHeaderProps
> = ({ isLoading, totalElements, searchTerm }) => {
  return (
    <StyledWrapper>
      <StyledTitle>{translate('enhancedSearch.successHeader')}</StyledTitle>
      {isLoading ? (
        <StyledSubTitle>{translate('search.loading')}</StyledSubTitle>
      ) : (
        <StyledSubTitle>
          <StyledSearchResultsNumber>
            {totalElements === 1
              ? translate('enhancedSearch.oneResultHeader')
              : translate('enhancedSearch.manyResultsHeader', {
                  totalElements: `${totalElements}`,
                })}
          </StyledSearchResultsNumber>
          {translate('enhancedSearch.inputResultHeader', {
            searchTerm,
          })}
        </StyledSubTitle>
      )}
    </StyledWrapper>
  )
}

export default EnhancedSearchResultsHeader
